import { http_client } from './api';
import config from 'config';
import { showSessionExpiredOverlay } from '../utils/sessionExpiredHandler';

const register = async (data) => {
  return http_client.post('register', data).then((response) => {
    return response.data;
  });
};

const login = async (email, password, remember = false) => {
  return http_client.get(config.baseApiUrl + 'sanctum/csrf-cookie').then(() => {
    return http_client
      .post('login', {
        email,
        password,
        remember
      })
      .then((response) => {
        localStorage.setItem('studentToken', response.data.data.token);
        localStorage.setItem('student', JSON.stringify(response.data.data.student));
        window.location.replace('/');
        return response.data;
      });
  });
};

const logout = async () => {
  try {
    await http_client.post('logout');
  } catch (error) {
    // Token mungkin sudah expired, tetap lanjut bersihkan localStorage
    console.warn('Logout API call failed:', error?.message);
  } finally {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/login');
  }
};

const clearAuth = () => {
  localStorage.clear();
  sessionStorage.clear();
  showSessionExpiredOverlay();
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('student'));
};

const AuthService = {
  register,
  login,
  logout,
  clearAuth,
  getCurrentUser
};

export default AuthService;
